import React from "react"
import { Container, Row, Col } from "react-bootstrap"

import WiczlinoHeader from "../../../components/estates/newwiczlino/wiczlinoHeader"
import Search from "../../../components/search/search_ogw2"
import Description from "../../../components/estates/newwiczlino/description"
import Visual from "../../../components/estates/newwiczlino/visual"
import LogBuilding from "../../../components/estates/logBuilding"
import Localization from "../../../components/estates/newwiczlino/localization"
import EstatePlan from "../../../components/estates/newwiczlino/estatePlan"
import Layout from "../../../components/layout"
import Helmet from "react-helmet"
import Modal from "../../../components/popup2/popup"
import { logs } from "../../../data/diary/buildingLogsOGW2"
import EstateVisualDownload from "@/components/estates/estateVisualDownload"
import EstateDisclaimer from "@/components/estates/estateDisclaimer"
import EstateHeader from "@/components/estates/estateHeader"
import JanowoTwoVisual from "@/components/estates/janowotwo/janowoTwoVisual"
import wizImage from "@/images/z-8/z-7i.jpg"
import wiz1a from "@/images/z-24/UJECIE1v4.jpg"
import wiz2a from "@/images/z-19/UJECIE4v3.jpg"
import wiz5b from "@/images/wiczlino-2/z6g.jpg"
import EstateFlatInfo from "@/components/estates/estateFlatInfo"
import { SearchContainer } from "@/components/search/searchStyles"
import { MobileButton } from "@/components/shared/button/button"

function Wiczlinodwa({ location }) {
  const scrollDestination =
    location && location.state && location.state.position
  return (
    <>
      <Helmet>
        <title>WILLBUD | Osiedle Gdynia Wiczlino II (Etap IIIB)</title>
      </Helmet>
      <Layout>
        <EstateHeader
          title={`Osiedle Gdynia Wiczlino II`}
          place={"GDYNIA, UL. KORMORANA"}
          // price={7543}
          promo={"NOWY ETAPY B JUŻ W SPRZEDAŻY"}
          inProgress
          noButton
        />
        <JanowoTwoVisual
          slides={[wizImage, wiz1a, wiz2a, wiz5b]}
          alt={`Osiedle Gdynia Wiczlino II Wizualizacja`}
        />

        <WiczlinoHeader scrollDestination={scrollDestination} />

        <Description />
        <Visual />
        <EstateVisualDownload />


        <Search />
        {/*
        <Container className="flats">
          <SearchContainer>
            <Row className="desktop-container">
              <Col xs="12" className="no-padding desktop-list-title">
                <h1 className="no-padding">
                  Lista Lokali
                </h1>
              </Col>
            </Row>
            <Row>
              <Col style={{'maxWidth': '600px', 'margin': '-30px auto 30px' }}>
                  <MobileButton
                    handleAction={() => {
                      document.getElementById(
                        "myModal"
                      ).style = {
                        display: "block",
                      }
                      document.getElementsByClassName(
                        "code"
                      )[0].innerText = 'Zapytaj o Osiedle Gdynia Wiczlino II, ETAP IIIB'

                    }}
                    bg="#94C835"
                    color="white"
                    border={"transparent"}
                    arrow={false}
                    smallArrow={false}
                  >
                    Zapytaj o Osiedle Gdynia Wiczlino II, ETAP IIIB
                  </MobileButton>

              </Col>
            </Row>
          </SearchContainer>
        </Container>
        */}
        {<Container className="no-padding">
          <Row>
            <Col lg={6} md={12}>
              { /*
              <p>
                Udział w działce drogowej: 15 000 zł brutto
              </p>
              <EstateFlatInfo >
                <p>
                  Niniejszy cennik obowiązuje od dnia 19.01.2026 r.
                </p>
              </EstateFlatInfo>
                */ }
            </Col>
            <Col lg={1} md={12}></Col>
            <Col lg={5} md={12}>
              <p><strong>Historia cen</strong></p>
              <p className={"price-info"}>

                <a href="/assets/files/ogw2/HISTORIA CEN OD DNIA 07.11.2025 DO DNIA 18.01.2026_OSIEDLE GDYNIA WICZLINO II.pdf" target="_blank" rel="nofollow">
                  <span>
                    CENNIK HISTORYCZNY OBOWIĄZUJĄCY OD DNIA 07.11.2025 DO DNIA 18.01.2026
                  </span>
              </a>
                <a href="/assets/files/ogw2/HISTORIA CEN OD DNIA 13.10.2025 DO DNIA 06.11.2025_OSIEDLE GDYNIA WICZLINO II.pdf" target="_blank" rel="nofollow">
                  <span>
                    CENNIK HISTORYCZNY OBOWIĄZUJĄCY OD DNIA 13.10.2025 DO DNIA 06.11.2025
                  </span>
              </a>
                <a href="/assets/files/ogw2/HISTORIA CEN OD DNIA 11.09.2025 DO DNIA 12.10.2025_OSIEDLE GDYNIA WICZLINO II.pdf" target="_blank" rel="nofollow">
                  <span>
                    CENNIK HISTORYCZNY OBOWIĄZUJĄCY OD DNIA 11.09.2025 DO DNIA 12.10.2025
                  </span>
                </a>
                <br/>
              </p>
              <p><strong>Prospekt informacyjny</strong></p>
              <p>
                <a href="/assets/files/ogw2/2026.07.09 - Osiedle Gdynia Wiczlino II - Etap III - Zad inw IIIB - Prospekt informacyjny.pdf?ts=20260727" target="_blank" rel="nofollow">
                  2026.07.09 - Osiedle Gdynia Wiczlino II - Etap III - Zad inw IIIB
                </a>
                <br/>
                <a href="/assets/files/ogw2/2026.02.24 - Osiedle Gdynia Wiczlino II - Etap III - Zad inw IIIA - Prospekt informacyjny.pdf" target="_blank" rel="nofollow">
                  2026.02.24 - Osiedle Gdynia Wiczlino II - Etap III - Zad inw IIIA
                </a>
              </p>
            </Col>
          </Row>


        </Container>
        }
        <EstatePlan scrollDestination={scrollDestination} />
        <Localization estate={"wiczlino2"} />
        <LogBuilding
          logs={logs.filter(l => l.etap)}
          anchor={`/pl/oferta/osiedle-gdynia-wiczlino-2/#diary`}
        />
        <EstateDisclaimer />
        <Modal />
      </Layout>
    </>
  )
}

export default Wiczlinodwa
